import { getBrowserLang } from "@jsverse/transloco";
import { LANGUAGE_STORAGE_KEY } from "@localization";
import { FALLBACK_LANGUAGE } from "../constants/i18n.constants";
import { LanguageCode } from "../models/i18n.models";

/**
 * Retrieves the default language for the application.
 *
 * @returns The default language as a string.
 * The priority for determining the language is:
 * 1. A stored language value in local storage.
 * 2. The browser's default language (if available).
 * 3. A fallback language.
 */
export const getDefaultLang = () => {
  // Attempt to retrieve the language value from local storage
  const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY) as LanguageCode;

  // Attempt to retrieve the browser's language if no value is found in local storage
  const browserLang = getBrowserLang();

  // Return the stored language, browser language, or fallback language as a default
  return storedLang ?? browserLang ?? FALLBACK_LANGUAGE;
};
